import React from 'react';

interface UserPlusProps {
    width?: number;
    height?: number;
    color?: string;
    className?: string;
}

const UserPlus: React.FC<UserPlusProps> = ({ width = 24, height = 24, color = 'currentColor', className = '' }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <g clipPath="url(#clip0_6010_28918)">
                <path
                    d="M16 17H8C7.07069 17 6.60603 17 6.21964 17.0769C4.63288 17.3925 3.39249 18.6329 3.07686 20.2196C3 20.606 3 21.0707 3 22H21C21 21.0707 21 20.606 20.9231 20.2196C20.6075 18.6329 19.3671 17.3925 17.7804 17.0769C17.394 17 16.9293 17 16 17Z"
                    fill={color === 'currentColor' ? '#E3ECF3' : color}
                />
                <circle
                    cx="12"
                    cy="8"
                    r="6"
                    fill={color === 'currentColor' ? '#9FA9BC' : color}
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.5 14C6.5 13.7239 6.27614 13.5 6 13.5C5.72386 13.5 5.5 13.7239 5.5 14V17H2.5C2.22386 17 2 17.2239 2 17.5C2 17.7761 2.22386 18 2.5 18H5.5V21C5.5 21.2761 5.72386 21.5 6 21.5C6.27614 21.5 6.5 21.2761 6.5 21V18H9.5C9.77614 18 10 17.7761 10 17.5C10 17.2239 9.77614 17 9.5 17H6.5V14Z"
                    fill={color === 'currentColor' ? '#1F1F1F' : color}
                />
            </g>
            <defs>
                <clipPath id="clip0_6010_28918">
                    <rect
                        width="24"
                        height="24"
                        fill="white"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default UserPlus;
